/**
 * ChatModule - Top-level entry point for the chat module.
 * Wraps ChatLayout + ChatProvider.
 */

import React from 'react';
import { ChatProvider } from '../../contexts/ChatContext';
import ChatLayout from './ChatLayout';

const ChatModule: React.FC = () => {
  return (
    <ChatProvider>
      <ChatLayout />
    </ChatProvider>
  );
};

export default ChatModule;
